import React, { Component } from 'react';
import { Film, MapPin, Camera, ChevronRight, Settings, Heart } from 'lucide-react';
export function ComponentShowcase() {
  return <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-11">
      {/* Cards Section */}
      <div className="space-y-8" data-id="element-12">
        <h3 className="text-sm font-bold text-film-gray uppercase tracking-wider mb-4" data-id="element-13">
          Card Components
        </h3>

        {/* Active Roll Card */}
        <div className="bg-white p-4 relative shadow-card group cursor-pointer hover:shadow-md transition-shadow" data-id="element-14">
          <div className="absolute left-0 top-0 bottom-0 w-1 bg-film-black" data-id="element-15"></div>
          <div className="flex justify-between items-start mb-2 pl-3" data-id="element-16">
            <h4 className="font-bold text-lg text-film-black" data-id="element-17">
              Lisbon Weekend Trip
            </h4>
            <div className="flex gap-2" data-id="element-18">
              <span className="bg-gray-200 text-film-gray text-xs px-2 py-0.5 font-medium" data-id="element-19">
                35mm
              </span>
              <span className="bg-film-red-light text-white text-xs px-2 py-0.5 font-bold" data-id="element-20">
                Loaded
              </span>
            </div>
          </div>
          <div className="pl-3 space-y-1" data-id="element-21">
            <div className="flex items-center text-film-gray text-sm" data-id="element-22">
              <Film className="w-3 h-3 mr-2" data-id="element-23" />
              <span data-id="element-24">Kodak Gold 200</span>
              <span className="ml-auto text-xs" data-id="element-25">ISO 200</span>
            </div>
            <div className="flex items-center text-film-gray text-sm" data-id="element-26">
              <Camera className="w-3 h-3 mr-2" data-id="element-27" />
              <span data-id="element-28">Nikon FM2</span>
            </div>
          </div>
          <div className="mt-4 pl-3 flex items-center justify-between border-t border-film-border pt-2" data-id="element-29">
            <div className="w-full bg-gray-100 h-1 rounded-full overflow-hidden mr-4" data-id="element-30">
              <div className="bg-film-red h-full w-1/4" data-id="element-31"></div>
            </div>
            <span className="text-xs text-film-gray whitespace-nowrap" data-id="element-32">
              4 frames
            </span>
          </div>
        </div>

        {/* Expired Roll Card */}
        <div className="bg-white p-4 relative shadow-card border border-film-red/20" data-id="element-33">
          <div className="absolute left-0 top-0 bottom-0 w-1 bg-film-red-light" data-id="element-34"></div>
          <div className="flex justify-between items-start mb-2 pl-3" data-id="element-35">
            <h4 className="font-bold text-lg text-film-black" data-id="element-36">
              Night Walk in Tokyo
            </h4>
            <div className="flex gap-2" data-id="element-37">
              <span className="bg-film-red text-white text-xs px-2 py-0.5 font-bold" data-id="element-38">
                Expired
              </span>
              <span className="bg-gray-200 text-film-gray text-xs px-2 py-0.5 font-medium" data-id="element-39">
                120
              </span>
            </div>
          </div>
          <div className="pl-3 space-y-1" data-id="element-40">
            <div className="flex items-center text-film-gray text-sm" data-id="element-41">
              <Film className="w-3 h-3 mr-2" data-id="element-42" />
              <span data-id="element-43">Cinestill 800T</span>
              <span className="ml-auto text-xs" data-id="element-44">ISO 800</span>
            </div>
          </div>
        </div>

        {/* Location Card */}
        <div className="bg-white p-4 relative shadow-card border border-film-border" data-id="element-45">
          <div className="absolute left-0 top-0 bottom-0 w-1 bg-film-border" data-id="element-46"></div>
          <div className="flex justify-between items-start pl-3" data-id="element-47">
            <div data-id="element-48">
              <h4 className="font-bold text-lg text-film-black" data-id="element-49">
                Photo Works Belfast
              </h4>
              <div className="flex items-center text-film-gray text-sm mt-1" data-id="element-50">
                <MapPin className="w-3 h-3 mr-1" data-id="element-51" />
                <span data-id="element-52">Belfast, UK</span>
                <span className="ml-2 bg-film-red/10 text-film-red text-[10px] px-1.5 py-0.5 font-bold uppercase" data-id="element-53">
                  Closed
                </span>
              </div>
            </div>
            <Heart className="w-5 h-5 text-film-gray hover:text-film-red transition-colors cursor-pointer" data-id="element-54" />
          </div>
          <div className="pl-3 mt-3" data-id="element-55">
            <span className="bg-blue-50 text-blue-600 text-xs px-2 py-1 font-medium" data-id="element-56">
              Film Development
            </span>
          </div>
        </div>
      </div>

      {/* Buttons & Badges Section */}
      <div className="space-y-12" data-id="element-57">
        <div data-id="element-58">
          <h3 className="text-sm font-bold text-film-gray uppercase tracking-wider mb-4" data-id="element-59">
            Buttons
          </h3>
          <div className="space-y-4" data-id="element-60">
            <button className="w-full bg-film-red hover:bg-red-700 text-white font-bold py-3 px-4 rounded-sm flex items-center justify-center gap-2 transition-colors" data-id="element-61">
              <span className="text-lg" data-id="element-62">✦</span> BECOME A PRO
            </button>
            <button className="w-full bg-white border border-film-black text-film-black font-bold py-3 px-4 rounded-sm hover:bg-gray-50 transition-colors" data-id="element-63">
              VIEW ALL ROLLS
            </button>
          </div>
        </div>

        <div data-id="element-64">
          <h3 className="text-sm font-bold text-film-gray uppercase tracking-wider mb-4" data-id="element-65">
            Status Badges
          </h3>
          <div className="flex flex-wrap gap-4" data-id="element-66">
            <span className="bg-film-red-light text-white text-xs px-2 py-1 font-bold" data-id="element-67">
              Loaded
            </span>
            <span className="bg-film-red text-white text-xs px-2 py-1 font-bold" data-id="element-68">
              Expired
            </span>
            <span className="bg-film-orange text-white text-xs px-2 py-1 font-bold" data-id="element-69">
              Expiring
            </span>
            <span className="bg-film-stored text-film-gray text-xs px-2 py-1 font-bold" data-id="element-70">
              Stored
            </span>
            <span className="bg-gray-200 text-film-gray text-xs px-2 py-1 font-medium" data-id="element-71">
              35mm
            </span>
          </div>
        </div>

        <div data-id="element-72">
          <h3 className="text-sm font-bold text-film-gray uppercase tracking-wider mb-4" data-id="element-73">
            Navigation Elements
          </h3>
          <div className="bg-film-nav p-4 rounded-lg flex justify-between items-center max-w-xs mx-auto" data-id="element-74">
            <div className="flex flex-col items-center gap-1 text-white" data-id="element-75">
              <div className="bg-white/10 p-1 rounded" data-id="element-76">
                <Film className="w-5 h-5" data-id="element-77" />
              </div>
              <span className="text-[10px]" data-id="element-78">Rolls</span>
            </div>
            <div className="w-12 h-12 bg-film-red rounded-full flex items-center justify-center -mt-8 border-4 border-film-nav shadow-lg" data-id="element-79">
              <Camera className="w-6 h-6 text-white" data-id="element-80" />
            </div>
            <div className="flex flex-col items-center gap-1 text-film-gray" data-id="element-81">
              <MapPin className="w-5 h-5" data-id="element-82" />
              <span className="text-[10px]" data-id="element-83">Labs</span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}